















































































import Component from 'vue-class-component'
import SharedFunctions from '../SharedFunctions'
import Icon from '../../../../../components/Icon.vue'
import { IResident, IStatement } from '@zunta/configurations'
import ScrollView from '@/components/ScrollView.vue'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'

@Component({
  components: {
    InputV2,
    StatusStatement,
    ScrollView,
    Icon
  }
})
export default class StatusFiltersV2 extends SharedFunctions {
  opened: any = ''
  hovered: any = ''
  search: string = ''

  get filterItems () {
    return [
      {
        text: 'All',
        statistic: this.statementList.length,
        type: 'ALL',
        selectedCase: this.statementsType === 'ALL' || this.statementsType === 'All'
      },
      {

        text: 'Needs Review',
        statistic: this.statistics.needsReviewAndFix,
        type: [
          this.EStatementStatuses.NEEDS_REVIEW,
          this.EStatementStatuses.NEEDS_FIX,
          this.EStatementStatuses.RETURNED,
          this.EStatementStatuses.EMAIL_RETURNED
        ],
        selectedCase:
            this.checkSelected([
              this.EStatementStatuses.NEEDS_REVIEW,
              this.EStatementStatuses.NEEDS_FIX,
              this.EStatementStatuses.RETURNED,
              this.EStatementStatuses.EMAIL_RETURNED
            ]),
        children: [
          {
            text: 'Unapproved',
            statistic: this.statistics.needsReview,
            type: this.EStatementStatuses.NEEDS_REVIEW,
            selectedCase: this.EStatementStatuses.NEEDS_REVIEW === this.statementsType
          },
          {
            text: 'Needs Fix',
            statistic: this.statistics.needsFix,
            type: this.EStatementStatuses.NEEDS_FIX,
            selectedCase: this.EStatementStatuses.NEEDS_FIX === this.statementsType
          },
          {
            text: 'Returned',
            statistic: this.statistics.returned,
            type: this.EStatementStatuses.RETURNED,
            selectedCase: this.EStatementStatuses.RETURNED === this.statementsType
          },
          {
            text: 'Email Returned',
            statistic: this.statistics.emailReturned,
            type: this.EStatementStatuses.EMAIL_RETURNED,
            selectedCase: this.EStatementStatuses.EMAIL_RETURNED === this.statementsType
          }
        ]
      },
      {
        text: 'Excluded',
        statistic: this.statistics.excluded,
        type: [
          this.EStatementStatuses.DO_NOT_BILL,
          this.EStatementStatuses.DO_NOT_BILL_NEGATIVE,
          this.EStatementStatuses.DO_NOT_BILL_ZERO,
          this.EStatementStatuses.DO_NOT_BILL_CONTROL,
          this.EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
          this.EStatementStatuses.DO_NOT_BILL_RETURNED,
          this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED
        ],
        selectedCase:
            this.checkSelected([
              this.EStatementStatuses.DO_NOT_BILL,
              this.EStatementStatuses.DO_NOT_BILL_NEGATIVE,
              this.EStatementStatuses.DO_NOT_BILL_ZERO,
              this.EStatementStatuses.DO_NOT_BILL_CONTROL,
              this.EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
              this.EStatementStatuses.DO_NOT_BILL_RETURNED,
              this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED
            ]),
        children: [
          {
            text: 'Excluded for this month',
            statistic: this.statistics.doNotBill,
            type: this.EStatementStatuses.DO_NOT_BILL,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL === this.statementsType
          },
          {
            text: 'Negative Balance',
            statistic: this.statistics.doNotBillNegative,
            type: this.EStatementStatuses.DO_NOT_BILL_NEGATIVE,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_NEGATIVE === this.statementsType
          },
          {
            text: 'Zero Balance',
            statistic: this.statistics.doNotBillZero,
            type: this.EStatementStatuses.DO_NOT_BILL_ZERO,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_ZERO === this.statementsType
          },
          {
            text: 'Low Balance',
            statistic: this.statistics.doNotBillControl,
            type: this.EStatementStatuses.DO_NOT_BILL_CONTROL,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_CONTROL === this.statementsType
          },
          {
            text: 'Permanently Excluded',
            statistic: this.statistics.doNotBillPermanently,
            type: this.EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_PERMANENTLY === this.statementsType
          },
          {
            text: 'Returned - Do Not Bill',
            statistic: this.statistics.doNotBillReturned,
            type: this.EStatementStatuses.DO_NOT_BILL_RETURNED,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_RETURNED === this.statementsType
          },
          {
            text: 'Email Returned - Do Not Bill',
            statistic: this.statistics.doNotBillEmailReturned,
            type: this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED,
            selectedCase: this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED === this.statementsType
          }
        ]
      },
      {
        text: 'Approved',
        statistic: this.statistics.approved,
        type: [this.EStatementStatuses.READY_TO_MAIL, this.EStatementStatuses.READY_TO_EMAIL, this.EStatementStatuses.READY_TO_PRINT],
        selectedCase: this.checkSelected([
          this.EStatementStatuses.READY_TO_MAIL,
          this.EStatementStatuses.READY_TO_EMAIL,
          this.EStatementStatuses.READY_TO_PRINT
        ]),
        children: [
          {
            text: 'Mail',
            statistic: this.statistics.readyToMail,
            type: this.EStatementStatuses.READY_TO_MAIL,
            selectedCase: this.EStatementStatuses.READY_TO_MAIL === this.statementsType
          },
          {
            text: 'EMail',
            statistic: this.statistics.readyToEmail,
            type: this.EStatementStatuses.READY_TO_EMAIL,
            selectedCase: this.EStatementStatuses.READY_TO_EMAIL === this.statementsType
          },

          {
            text: 'Deliver Locally',
            statistic: this.statistics.readyToPrint,
            type: this.EStatementStatuses.READY_TO_PRINT,
            selectedCase: this.EStatementStatuses.READY_TO_PRINT === this.statementsType
          }
        ]
      }
    ]
  }

  get searchStatements () {
    const nameParts = this.search.replace(/#/gm, '').split(' ')
    return this.statementList.filter((statement: IStatement) => {
      const resident = statement.resident as IResident
      if (nameParts.length > 1) {
        return (resident.firstName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
            (resident.lastName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
            (resident.firstName.toLowerCase()).startsWith(nameParts[1].toLowerCase()) ||
            (resident.lastName.toLowerCase()).startsWith(nameParts[1].toLowerCase())
      }
      return (resident.firstName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
          (resident.lastName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
          (resident.ncsResidentId && resident.ncsResidentId.includes(nameParts[0].toLowerCase())) ||
          (resident.originid && resident.originid.includes(nameParts[0].toLowerCase()))
    })
  }

  created () {
    this.unwatch = this.$watch('statistics', () => {
      const selected = this.filterItems.find((filterItem: any) => {
        return !!filterItem.selectedCase
      })
      if (selected && selected.text !== 'ALL') {
        this.opened = selected.text
      }
      this.unwatch()
    })
  }

  checkSelected (checkArr: string[]) {
    if (typeof this.statementsType === 'string') {
      return checkArr.includes(this.statementsType)
    }
    return this.statementsType.some((r: any) => checkArr.indexOf(r) >= 0)
  }

  toggleOpen (type: string) {
    if (this.opened === type) {
      this.opened = ''
      return
    }
    this.opened = type
  }

  changeStat (type: any) {
    if (!this.opened) {
      return
    }
    this.changeStatementsType(type)
  }
}
